import BaseApi from './BaseApi'
import { serialize } from 'object-to-formdata'

export default class Catalog extends BaseApi {
  autocomplete (query, options = {}) {
    return this.axios.get('/catalog/product/autocomplete', { params: { query }, ...options })
  }

  search (params, options = {}) {
    if (Object.values(params).some((value) => value instanceof File)) {
      return this.searchByFile(params, options)
    }
    return this.axios.post('/catalog/product/index', params, options)
  }

  searchByFile (params, options = {}) {
    const formData = serialize(params)
    return this.axios.post('/catalog/product/index', formData, {
      ...options,
      ...{
        headers: this.defaultPostHeaders
      }
    })
  }

  range () {
    return this.axios.get('/catalog/filter/range')
  }

  common () {
    return this.axios.get('/catalog/filter/common')
  }

  rates () {
    return this.axios.get('/catalog/product/rates')
  }

  lines (params) {
    return this.axios.get('/catalog/product/lines', { params })
  }
}
